import { render, staticRenderFns } from "./StaffDetail.vue?vue&type=template&id=759f77b7&scoped=true&"
import script from "./StaffDetail.vue?vue&type=script&lang=js&"
export * from "./StaffDetail.vue?vue&type=script&lang=js&"
import style0 from "./StaffDetail.vue?vue&type=style&index=0&id=759f77b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759f77b7",
  null
  
)

export default component.exports